var storefrontApp = angular.module('storefrontApp');
storefrontApp.controller("MembershipController",
    ["$rootScope", "$scope", "$window", "urlService", "cookiesFactory", "membershipService", "accountService", "configs", "$timeout", "randomService", "membershipElasticService", "cartService", "commonService",
        function ($rootscope, $scope, $window, urlService, cookiesFactory, membershipService, accountService, configs, $timeout, randomService, elasticService, cartService, commonService) {
            $scope.planToPurchase;
            $scope.isMemberBenefitsLoaded = true;
            $scope.isClubDataLoaded = false;
            $scope.isFreeProductsLoaded = false;
            $scope.windowWidth = $window.innerWidth;
            $scope.isCircleMember = false;
            $scope.isTenurePromotionActive = false;
            $scope.freeProducts = [];
            $scope.atgDesignPacks = [];
            $scope.atgStabilizers = [];
            $scope.atgFonts = [];
            $scope.goodieSamplesMaster = [];
            $scope.goodieSamples = [];
            $scope.goodiesContentLoaded = false;

            if (
                $window.__env &&
                $window.__env.IsTenurePromotionActive &&
                $window.__env.TenurePromotionCreditMonths
            ) {
                var tenurePromoMonths = $window.__env.TenurePromotionCreditMonths;
                $scope.isTenurePromotionActive = true;
                $scope.tenurePromoLabel =
                    "+" +
                    tenurePromoMonths +
                    " free month" +
                    (tenurePromoMonths > 1 ? "s" : "") +
                    " bonus";
            }

            $scope.showTenurePromoForPlan = function (plan) {
                if (!$scope.isTenurePromotionActive || !plan) {
                    return false;
                }
                var tenure = parseInt(plan.planTenure, 10);
                return tenure === 12 || tenure === 24;
            };

            function scheduleIdleWork(fn) {
                if ($window.requestIdleCallback) {
                    $window.requestIdleCallback(function () {
                        $scope.$applyAsync(fn);
                    }, { timeout: 2500 });
                } else {
                    $timeout(fn, 1);
                }
            }

            function whenNearViewport(selector, fn) {
                var el = $window.document.querySelector(selector);
                if (!$window.IntersectionObserver || !el) {
                    scheduleIdleWork(fn);
                    return;
                }
                var observer = new $window.IntersectionObserver(function (entries) {
                    for (var i = 0; i < entries.length; i++) {
                        if (entries[i].isIntersecting) {
                            observer.disconnect();
                            $scope.$applyAsync(fn);
                            return;
                        }
                    }
                }, { rootMargin: '240px 0px' });
                observer.observe(el);
            }

            getCustomerInfo = function () {
                accountService.getCustomerInfo().then(
                    function (response) {
                        if (response) {
                            $scope.contact = response.data.contact;
                            if ($scope.contact && $scope.contact.email) {
                                $scope.GetClubMembershipInfo();
                            }
                            if ($scope.isAnnsClubMember) {
                                $scope.getMembershipGoodies();
                            }
                        }
                    }
                );
            };
            getCustomerInfo();

            $scope.getMembershipGoodies = function () {
                accountService.getMembershipGoodies($scope.contact.id).then(function (response) {
                    if (response && response.data) {
                        $scope.goodies = response.data;
                    }
                });
            };

            $scope.getMembershipPlans = function () {
                membershipService.getMembershipPlans().then(function (response) {
                    if (response && response.data && response.data.length) {
                        $scope.membershipPlans = response.data;
                        $scope.selectedPlan = response.data[0].planTenure.toString();
                        $scope.planToPurchase = response.data[0];
                        if (window.__env.newMembershipPlanTenures && window.__env.newMembershipPlanTenures.length > 0) {
                            $scope.membershipPlans.forEach(function (plan) {
                                if (window.__env.newMembershipPlanTenures.indexOf(plan.planTenure) > -1) {
                                    plan.isNewPlan = true;
                                }
                            });
                        }
                    }
                    $scope.isClubDataLoaded = true;
                }).catch(function () {
                    $scope.isClubDataLoaded = true;
                });
            };
            $scope.getMembershipPlans();

            $scope.onBtnClick = function () {
                if (angular.isDefined($scope.planToPurchase)) {
                    $rootscope.showLoader = true;
                    cartService.addMembershipCart($scope.planToPurchase.planId, $scope.planToPurchase.planTenure).then(function (response) {
                        if (response && response.data) {
                            $rootscope.showLoader = false;
                            $window.location.href = "cart/checkout";
                        } else {
                            $rootscope.showLoader = false;
                            $window.location.href = "/account/login?ReturnUrl=/annsclub";
                        }
                    });
                }
            };

            function getSourceClubPrice(hit) {
                if (!hit || !hit._source) {
                    return null;
                }
                var clubPrice = hit._source.clubPrice;
                if (clubPrice === undefined || clubPrice === null || clubPrice === '') {
                    return null;
                }
                return Number(clubPrice);
            }

            function pickLowestClubPriceProducts(hits, limit) {
                limit = limit || 4;
                if (!hits || !hits.length) {
                    return [];
                }
                var qualified = hits.filter(function (hit) {
                    var src = hit._source || {};
                    var clubPrice = getSourceClubPrice(hit);
                    if (clubPrice === null || clubPrice < 0) {
                        return false;
                    }
                    var listPrice = Number(src.listPrice);
                    var salePrice = Number(src.salePrice);
                    if (!(listPrice > 0)) {
                        return false;
                    }
                    var bestNonClub = listPrice;
                    if (salePrice > 0 && salePrice < bestNonClub) {
                        bestNonClub = salePrice;
                    }
                    return clubPrice <= bestNonClub;
                });
                var pool = qualified.length ? qualified : hits.slice();
                pool.sort(function (a, b) {
                    var aClub = getSourceClubPrice(a);
                    var bClub = getSourceClubPrice(b);
                    if (aClub === null && bClub === null) {
                        return 0;
                    }
                    if (aClub === null) {
                        return 1;
                    }
                    if (bClub === null) {
                        return -1;
                    }
                    return aClub - bClub;
                });
                return pool.slice(0, limit);
            }

            function fetchElasticHits(requestBuilder) {
                return commonService.getElasticData(
                    configs.elasticBaseUrl,
                    requestBuilder()
                ).then(function (response) {
                    if (response && response.data && response.data.hits && response.data.hits.hits) {
                        return response.data.hits.hits;
                    }
                    return [];
                }).catch(function (error) {
                    console.error('Error fetching club benefit products', error);
                    return [];
                });
            }

            function getClubExclusiveFreeProducts() {
                commonService.getElasticData(
                    configs.elasticBaseUrl,
                    elasticService.buildClubExclusiveFreeProductsRequest()
                ).then(function (response) {
                    if (response && response.data && response.data.aggregations) {
                        var buckets = response.data.aggregations.free_products.buckets;
                        if (buckets && buckets.length && buckets[0].free_products) {
                            $scope.freeProducts = randomService.getRandomItems(
                                buckets[0].free_products.hits.hits,
                                4
                            );
                        }
                    }
                    $scope.isFreeProductsLoaded = true;
                }).catch(function (error) {
                    console.error('Error fetching free products', error);
                    $scope.isFreeProductsLoaded = true;
                });
            }

            function getClubBenefitProductRows() {
                fetchElasticHits(elasticService.buildAtgDesignPacksRequest).then(function (hits) {
                    $scope.atgDesignPacks = pickLowestClubPriceProducts(hits, 4);
                });
                fetchElasticHits(elasticService.buildAtgStabilizersRequest).then(function (hits) {
                    $scope.atgStabilizers = pickLowestClubPriceProducts(hits, 4);
                });
                fetchElasticHits(elasticService.buildAtgFontsRequest).then(function (hits) {
                    $scope.atgFonts = pickLowestClubPriceProducts(hits, 4);
                });
            }

            // Defer below-fold Elastic until near viewport / idle
            whenNearViewport('.free-designs', getClubExclusiveFreeProducts);
            whenNearViewport('.club-benefit-products', getClubBenefitProductRows);

            var resizeTimer = null;
            angular.element($window).bind('resize', function () {
                $scope.windowWidth = $window.innerWidth;
                if (resizeTimer) {
                    $timeout.cancel(resizeTimer);
                }
                resizeTimer = $timeout(function () {
                    $scope.getActiveGoodies();
                }, 150);
            });

            $scope.getActiveGoodiesLength = function () {
                // Keep in sync with .samples .sample widths in club_landingpage.scss
                if ($scope.windowWidth >= 992) {
                    return 4;
                }
                if ($scope.windowWidth < 768) {
                    return 1;
                }
                return 3;
            };

            $scope.getActiveGoodies = function () {
                if (angular.isDefined($scope.goodieSamples) && $scope.goodieSamplesMaster && $scope.goodieSamplesMaster.length) {
                    var len = $scope.getActiveGoodiesLength();
                    if (len != $scope.goodieSamples.length) {
                        $scope.activeIndex = len - 1;
                        $scope.goodieSamples = $scope.goodieSamplesMaster.slice(0, len);
                    }
                }
            };

            $scope.onNavClick = function (navOption) {
                switch (navOption) {
                    case 'prev':
                        if ($scope.activeIndex - $scope.getActiveGoodiesLength() + 1 > 0) {
                            $scope.activeIndex = $scope.activeIndex - 1;
                            $scope.goodieSamples.pop();
                            $scope.goodieSamples.unshift(
                                $scope.goodieSamplesMaster[$scope.activeIndex - $scope.getActiveGoodiesLength() + 1]
                            );
                        }
                        break;
                    default:
                        if ($scope.activeIndex < $scope.goodieSamplesMaster.length - 1) {
                            $scope.activeIndex = $scope.activeIndex + 1;
                            $scope.goodieSamples.splice(0, 1);
                            $scope.goodieSamples.push($scope.goodieSamplesMaster[$scope.activeIndex]);
                        }
                        break;
                }
            };

            $scope.onGoodieKeydown = function ($event, navOption) {
                if (!$event) {
                    return;
                }
                var key = $event.keyCode || $event.which;
                if (key === 13 || key === 32) {
                    $event.preventDefault();
                    $scope.onNavClick(navOption);
                }
            };

            $scope.clearGoodieSamples = function () {
                $scope.goodieSamplesMaster = [];
                $scope.goodieSamples = [];
                $scope.goodiesContentLoaded = true;
            };

            $scope.getGoodiesContent = function () {
                membershipService.getGoodiesContent().then(function (response) {
                    if (response && response.data && response.data.length > 0) {
                        $scope.goodieSamplesMaster = response.data;
                        angular.forEach($scope.goodieSamplesMaster, function (goodies) {
                            goodies.imgUrl = urlService.getGoodieImageUrl(goodies.directory, goodies.sample);
                        });
                        $scope.goodieSamples = angular.copy(response.data.slice(0, $scope.getActiveGoodiesLength()));
                        $scope.activeIndex = $scope.getActiveGoodiesLength() - 1;
                        $scope.goodiesContentLoaded = true;
                        $scope.getActiveGoodies();
                    } else {
                        $scope.clearGoodieSamples();
                    }
                }).catch(function () {
                    $scope.clearGoodieSamples();
                });
            };

            whenNearViewport('.goodies-host', $scope.getGoodiesContent);

            $scope.setSelectedPlan = function (selectedPlan) {
                $scope.planToPurchase = selectedPlan;
            };

            $scope.onGoodieDownload = function () {
                var expiryDate = new Date().setDate(new Date().getDate() - 1);
                document.cookie = "downloadGoodies=" + "'';" + expiryDate + ";path=/";
                $scope.checkGoodiesCookieExists("downloadGoodies");
            };

            $scope.checkGoodiesCookieExists = function (name) {
                $scope.showDownloadingModal = true;
                $timeout(function () {
                    var goodie = cookiesFactory.get('downloadGoodies');
                    if (goodie == null || goodie == "''") {
                        $scope.checkGoodiesCookieExists();
                    } else {
                        $scope.showDownloadingModal = false;
                    }
                }, 1000);
            };

            $scope.closeDownloadingModal = function () {
                $scope.showDownloadingModal = false;
            };

            $scope.scrollTo = function () {
                $scope.scrollToPricing();
            };

            $scope.scrollToPricing = function () {
                var pricing = $window.document.getElementById('club-pricing');
                var top = 0;
                if (pricing) {
                    var rect = pricing.getBoundingClientRect();
                    top = Math.max(0, Math.round(rect.top + ($window.pageYOffset || $window.document.documentElement.scrollTop || 0) - 24));
                }
                try {
                    if (pricing && typeof pricing.scrollIntoView === 'function') {
                        pricing.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        return;
                    }
                } catch (e) { /* older browsers reject options object */ }
                if ($window.scrollTo) {
                    try {
                        $window.scrollTo({ top: top, left: 0, behavior: 'smooth' });
                        return;
                    } catch (e2) { /* fall through */ }
                    $window.scrollTo(0, top);
                }
            };

            $scope.onTrailMembershipCheckout = function () {
                if ($scope.contact && $scope.contact.id) {
                    $window.location.href = "/annsclub/annsclubtrialcheckout";
                } else {
                    $window.location.href = "/account/login?ReturnUrl=/annsclub";
                }
            };

            $scope.GetClubMembershipInfo = function () {
                accountService
                    .getCustomerMembershipDetails($scope.contact.id)
                    .then(function (response) {
                        if (response && response.data) {
                            $scope.membership = response.data;
                            $scope.isCircleMember = true;
                            $scope.isCircleMemberActive = $scope.membership.isActive;
                        } else {
                            $scope.isCircleMember = false;
                        }
                    });
            };
        }
    ]);
